<app-error-screen-layout [logoAlt]="copy.logoAlt">
  <h1>{{ copy.heading }}</h1>
  <p>{{ copy.body }}</p>
  @if (isAuthCause) {
    <button type="button" class="home-link" (click)="recover('interactive-reauth')">{{ copy.signInLink }}</button>
    <button type="button" class="home-link secondary" (click)="recover('go-home')">{{ copy.homeLink }}</button>
  } @else {
    <button type="button" class="home-link" (click)="recover('go-home')">{{ copy.homeLink }}</button>
  }
</app-error-screen-layout>